window.addEventListener('DOMContentLoaded', () => {
    let isSliderInitialized = false;
    let intervalTimer;

    const mobileSliders = document.querySelectorAll('.lookeen__mobile__slider');
    let initialDomElements = [];

    // Cache original slider elements only once when DOM is loaded
    mobileSliders.forEach((slider) => {
        let sliderItems = slider.querySelectorAll('.lookeen__mobile__slide');
        initialDomElements.push(Array.from(sliderItems)); // Store each slider's elements in an array
    });

    const initSlider = () => {
        const isMobile = window.innerWidth < 768;

        mobileSliders.forEach((slider, index) => {
            let currentSlide = 0;
            let minHeight = 585;
            let sliderItemsArray = initialDomElements[index]; // Get the correct cached elements

            if (isMobile) {
                // Only initialize the slider if it hasn't been initialized yet
                if (!isSliderInitialized) {
                    isSliderInitialized = true;
                    repaintCanvas(slider, sliderItemsArray); // Repaint for mobile

                    // Initialize slider functionality and display first slide instantly
                    startSlider(slider, sliderItemsArray, minHeight);
                }
            } else {
                // Repaint desktop view (no slider)
                if (isSliderInitialized) {
                    isSliderInitialized = false;
                    clearInterval(intervalTimer); // Clear the interval if it exists
                    repaintCanvas(slider, sliderItemsArray); // Repaint for desktop
                }
            }
        });
    };

    const startSlider = (slider, sliderItemsArray, minHeight) => {
        let sliderWrap = document.createElement('div');
        sliderWrap.classList.add('lookeen__mobile__slider__wrap');
        slider.innerHTML = ''; // Clear existing slider content
        slider.appendChild(sliderWrap);

        let sliderNav = document.createElement('div');
        sliderNav.classList.add('slider__navigation');
        slider.appendChild(sliderNav);

        sliderItemsArray.forEach((_, index) => {
            let navItem = document.createElement('a');
            navItem.classList.add('slider__navigation-item');
            navItem.setAttribute('data-slider', index);
            if (index === 0) navItem.classList.add('active'); // First item active
            sliderNav.appendChild(navItem);
        });

        let currentSlide = 0;
        let numberOfItems = sliderItemsArray.length;

        const runSlider = () => {
            sliderWrap.innerHTML = ''; // Clear slider wrap
            let sliderItem = sliderItemsArray[currentSlide].cloneNode(true); // Clone the slide item
            sliderWrap.appendChild(sliderItem); // Add current slide
            sliderItem.style.opacity = 0;

            setTimeout(() => (sliderItem.style.opacity = 1), 100); // Fade in

            // Set slider height to the height of the current slide
            sliderItem.style.minHeight = `${minHeight}px`;

            sliderNav.querySelectorAll('.slider__navigation-item').forEach(item => item.classList.remove('active'));
            sliderNav.querySelector(`[data-slider="${currentSlide}"]`).classList.add('active');

            currentSlide = (currentSlide + 1) % numberOfItems; // Loop through slides
        };

        // Call runSlider immediately for the first slide
        runSlider();

        // Start slider interval
        intervalTimer = setInterval(runSlider, 3000);

        sliderNav.addEventListener('click', (e) => {
            if (e.target.classList.contains('slider__navigation-item')) {
                clearInterval(intervalTimer); // Stop interval on manual click
                currentSlide = parseInt(e.target.getAttribute('data-slider'));
                runSlider();
                intervalTimer = setInterval(runSlider, 3000); // Restart interval
            }
        });
    };

    function repaintCanvas(slider, sliderItemsArray) {
        console.log('Repainting canvas');

        // Use cloneNode to prevent removing elements from the original array
        slider.innerHTML = sliderItemsArray.map(item => item.cloneNode(true).outerHTML).join(''); // Rebuild slider content
    }

    initSlider();

    window.addEventListener('resize', () => {
        initSlider();
    });
});
